var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('Left'),_vm._v(" "),_c('Right')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }